export default __webpack_public_path__ + "static/media/emptyCart.a25b6874.svg";